import { useTheme } from './useTheme';
const borderRadiusMap = {
  sm: '0.125rem',
  default: '3px',
  md: '0.25rem',
  lg: '0.5rem',
  xl: '1rem',
  xxl: '2rem',
  full: '100%'
};
export const useTokens = () => {
  const {
    borderRadius,
    borderWidth,
    boxShadow,
    breezeColors,
    color,
    space,
    isTrellisLight
  } = useTheme();
  const success = color['fill-positive-default'];
  const warning = color['fill-caution-default'];
  const successGradient = `linear-gradient(89deg, ${success} 0%, ${color['fill-info-default']} 100%)`;
  const warningGradient = `linear-gradient(89deg,${color['fill-accent-light-orange-default']} 0%, ${warning} 100%)`;
  const tokens = {
    backgroundColor: {
      default: color['fill-surface-recessed'],
      dark: color['text-core-default'],
      light: color['fill-surface-default']
    },
    borderColor: {
      default: color['border-core-subtle'],
      dark: color['border-core-default'],
      light: color['border-core-disabled']
    },
    borderWidth: {
      default: borderWidth[100],
      double: borderWidth[200]
    },
    borderRadius: {
      sm: borderRadiusMap.sm,
      default: borderRadius[100],
      md: borderRadiusMap.md,
      lg: borderRadiusMap.lg,
      xl: borderRadiusMap.xl,
      xxl: borderRadiusMap.xxl,
      full: borderRadiusMap.full
    },
    breezeBrand: {
      default: breezeColors.primary.default,
      dark: breezeColors.primary.dark,
      light: breezeColors.primary.light,
      extraLight: breezeColors.primary.extraLight,
      extraExtraLight: breezeColors.primary['2xLight'],
      secondary: {
        default: breezeColors.secondary.default,
        light: breezeColors.secondary.light,
        extraLight: breezeColors.secondary.extraLight,
        extraExtraLight: breezeColors.secondary['2xLight']
      },
      gradient: {
        dark: breezeColors.gradient.dark,
        light: breezeColors.gradient.light,
        medium: breezeColors.gradient.medium
      }
    },
    dataViz: {
      dataViz1: color['fill-accent-orange-default'],
      // ORANGE
      dataViz2: color['fill-info-default'],
      // AQUA
      dataViz3: color['fill-accent-purple-default'],
      // PURPLE
      dataViz4: color['fill-accent-yellow-default'],
      // YELLOW
      dataViz5: color['fill-accent-red-default'],
      // RED
      dataViz6: color['text-core-disabled'],
      // GREY
      dataViz7: color['fill-accent-green-default'],
      // GREEN
      dataViz8: color['fill-accent-magenta-default'],
      // MAGENTA
      disabled: color['fill-primary-disabled']
    },
    gradient: {
      success: isTrellisLight ? success : successGradient,
      warning: isTrellisLight ? warning : warningGradient,
      danger: color['fill-alert-default']
    },
    shadow: {
      card: boxShadow[100],
      xs: boxShadow[100],
      sm: boxShadow[200],
      md: boxShadow[300],
      lg: boxShadow[400]
    },
    space: {
      xxxxs: space[25],
      xxxs: space[50],
      xxs: space[100],
      xs: space[200],
      sm: space[300],
      default: space[400],
      md: space[600],
      lg: space[800],
      xl: space[1000],
      xxl: space[1100],
      xxxl: space[1400],
      xxxxl: space[1500]
    },
    textColor: {
      base: color['text-core-default'],
      danger: color['text-alert-default'],
      disabled: color['text-core-disabled'],
      extraLight: color['text-core-subtle'],
      light: color['text-core-subtle'],
      inverse: color['text-core-on-fill-default']
    }
  };
  return {
    tokens
  };
};